import Colors from '../../../../Configs/colors';

const styles = {
  root: {
    padding: '24px 0 100px',
    backgroundColor: Colors.white,
    height: '100vh',
    boxSizing: 'border-box',
    overflow: 'auto',
    // '& .form-section': {
    //   height: '70vh',
    //   overflow: 'auto',
    // },
    '& .floating-action': {
      backgroundColor: Colors.white,
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      paddingBottom: 24,
      paddingTop: 4,
    },
  },
  address: {
    '& .address-card': {
      background: '#ECF5F8',
      borderRadius: 8,
      padding: 12,
      marginBottom: 16,
      boxShadow: '2px 3px 6px rgba(0, 0, 0, 0.04), 0px 2px 8px rgba(0, 0, 0, 0.02)',
      cursor: 'pointer',
    },
    '& .main-address': {
      background: '#47AE5B',
      padding: '6px 8px',
      borderRadius: 8,
    },
  },
};

export default styles;
